
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenReleaseNote {

    buildIdentifier: string;
    majorVersion: number;
    minorVersion: number;
    notes: string;
    patchVersion: number|undefined;
    released: moment.Moment;

    constructor();
    constructor( jsonObj: any );
    constructor( genReleaseNote: GenReleaseNote);

    constructor( input?: GenReleaseNote ) {
        if ( input && typeof input !== 'number' ) {
            this.buildIdentifier = input.buildIdentifier; // string [string]
            this.majorVersion = input.majorVersion; // int [number]
            this.minorVersion = input.minorVersion; // int [number]
            this.notes = input.notes; // string [string]
            this.patchVersion = input.patchVersion; // int [number]
            if ( input.released && typeof input.released === 'string' ) {
                this.released = moment(input.released).utc();
            } else {
                this.released = input.released;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenReleaseNote[] {
        if (arr && arr.map) {
          return arr.map(a => new GenReleaseNote(a));
        } else {
          return [];
        }
    }
}

